import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import { deacService } from '../../services/central-api/deac';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { StyleProp, TextStyle } from 'react-native';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    zIndex: number;
    actingBodyId: number;
    labelFontSize?: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
}

export default function VacancyLevelDropdown({ value, setValue, zIndex, actingBodyId, labelFontSize, labelStyle, viewStyle }: Props) {
    const [selectableVacancyLevels, setSelectableVacancyLevels] = useState<{ label: string; value: number; }[]>([]);

    async function loadVacancyLevels() {
        try {
            const vacancyLevels = await deacService.getVacancyLevelsSimplified(actingBodyId);
            setSelectableVacancyLevels(vacancyLevels.map((vacancyLevel) => {
                return {
                    value: vacancyLevel.id,
                    label: vacancyLevel.name,
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId && actingBodyId > 0) {
            loadVacancyLevels();
        }
    }, [actingBodyId]);

    return (
        <FilterDropdown
            label={translate('vacancyLevels')}
            items={selectableVacancyLevels}
            multiple={true}
            mode='BADGE'
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelFontSize={labelFontSize}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}
